let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iJJiN")).then(() => parcelRequire('h0Z52'));